import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TeamInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('amlogin')) {
      const teamToken = JSON.parse(sessionStorage.getItem('team-token'));
      request = request.clone({
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
          ...(teamToken && teamToken.access_token) && { 'Authorization': `Bearer ${teamToken.access_token}` }
        })
      });
    }
    return next.handle(request);
  }
}
